<div class="public-link__container">
  <div class="public-link__container-show-info"
    [ngClass]="{'public-link__container-show-info--open': publicLink.showInfo}">
    @if(publicLink.showInfo){
      <div class="public-link__container-button-show-info">
        <button class="common-button__icon-md-noborder rotate-90"
          (click)="publicLink.showInfo = false">
          <i class="lf-icon-collapse common-icon__md"></i>
        </button>
      </div>
      <div class="public-link__container-inner-show-info">
        <div class="public-link__container-text-info">
          <div class="public-link__container-text-info-title-principal"
            [afTranslate]="'public-link.public-concept'">_Concepto público</div>
          <div class="public-link__text-info"
            [afTranslate]="'public-link.info-one'">_Es un concepto que permite ser compartido de forma pública, de manera que cualquier persona que acceda a la URL generada pueda editarlo.</div>
        </div>
        <div class="public-link__container-text-info">
          <div class="public-link__container-text-info-title"
            [afTranslate]="'public-link.what-is-for'">_¿Para qué sirve?</div>
          <div class="public-link__text-info">
            <span [afTranslate]="'public-link.uses'"></span>
            <ul class="list-disc pl-[22px]">
              <li [afTranslate]="'public-link.use-one'"></li>
              <li [afTranslate]="'public-link.use-two'"></li>
            </ul>
          </div>
        </div>
        <div class="public-link__container-text-info">
          <div class="public-link__container-text-info-title"
            [afTranslate]="'public-link.configuration'">_¿Cómo se configura?</div>
          <div class="public-link__text-info">
            <div class="public-link__text-info">
              <span [afTranslate]="'public-link.steps-recomendation'"></span>
              <ol class="list-decimal pl-[22px]">
                <li [afTranslate]="'public-link.recomendation-one'"></li>
                <li [afTranslate]="'public-link.recomendation-two'"></li>
                <li [afTranslate]="'public-link.recomendation-three'"></li>
              </ol>
            </div>
          </div>
        </div>
        <div class="public-link__container-text-info">
          <div class="public-link__container-text-info-title"
            [afTranslate]="'public-link.link-activate'">_¿Cuándo se activa el enlace?</div>
          <div class="public-link__text-info"
            [afTranslate]="'public-link.info-two'">_Es un concepto que permite ser compartido de forma pública, de manera que cualquier persona que acceda a la URL generada pueda editarlo.</div>
        </div>
      </div>
    }@else {
      <button class="common-button__icon-lg-noborder"
        (click)="publicLink.showInfo = true">
        <i class="lf-icon-info-full common-icon__md"></i>
      </button>
    }
  </div>
  <div class="public-link__main-container"
    [ngClass]="{'public-link__main-container--open-info': publicLink.showInfo}">
    @if (publicLink.published){
      <div class="public-link__info-header-container-published">
        <button-with-text-menu
          [item]="publicLink.shareUrlItem"
          [buttonClass]="'common-button__text-noborder'"
          [textButton]="'public-link.share-url' | afTranslate"
          [multiline]="1"
          [disabled]="!concept.url"
          (launchActionEmitter)="launchActionLink($event.option)">
        </button-with-text-menu>
      </div>
    }@else {
      <div class="public-link__info-header-container"
        [afTranslate]="'public-link.title-steps'">
        _Vas a compartir públicamente este concepto. Por favor, revisa los siguientes pasos antes de publicar.
      </div>
    }
    <div class="public-link__container-cards">
      <button class="common-button-card__container"
        [ngClass]="{ 'common-button-card__container--error': publicLink.corporativeInformation.error}"
        (click)="editCorporativeInformation()">
        <div class="common-button-card__header-container">
          <div class="common-button-card__title-container"
            [ngClass]="{'common-button-card__title-container--error': publicLink.corporativeInformation.error}">
            <div class="common-button-card__inner-title"
              [afTranslate]="'public-link.corporative-information'">
              _Información corporativa
            </div>
            <i class="lf-icon-colour common-icon__xl"></i>
          </div>
          <span class="common-button-card__description"
            [afTranslate]="'public-link.corporative-information-text'">
            _El concepto público se mostrará en un espacio web independiente. Por ese motivo, es obligatorio añadir elementos corporativos que representen a la organización y faciliten al usuario una vía de contacto.
          </span>
        </div>
        @if(publicLink.corporativeInformation.publishConcept.global || (!publicLink.corporativeInformation.publishConcept.global && publicLink.corporativeInformation.configurated)){
          <div class="common-tag__neutral-light">
            <span class="common-tag__neutral-label-text"
              [afTranslate]="publicLink.corporativeInformation.publishConcept.global?'public-link.configure-global-applied':'public-link.configure-specific-applied'">
              Personalización específica aplicada
            </span>
          </div>
        }
        <div class="common-button-card__footer-buttons">
          <div class="common-tag__mandatory-obligatory-message">
            <span class="common-tag__mandatory-text-asterisk">*</span>
            <span [ngClass]="{'common-tag__mandatory-label-text-obligatory--error': publicLink.corporativeInformation.error }"
              class="common-tag__mandatory-label-text-obligatory"
              [afTranslate]="'common.required-with-bracket'">
              (obligatorio)
            </span>
          </div>
          <div class="common-tag__warning-risk-xl"
            [ngClass]="publicLink.corporativeInformation.configurated?'common-tag__warning-risk-xl--filled-green-disabled':'common-tag__warning-risk-xl--filled-red-disabled'">
            <i class="common-icon__md"
              [ngClass]="publicLink.corporativeInformation.configurated?'lf-icon-check-round':'lf-icon-track-right'"></i>
            <span class="common-tag__warning-risk-label-text"
              [afTranslate]="publicLink.corporativeInformation.configurated?'common.completed':'common.pending'">
              _Completado
            </span>
          </div>
        </div>
      </button>
      <button class="common-button-card__container"
        [ngClass]="{ 'common-button-card__container--error': publicLink.errorHasProcessOps}"
        (click)="processManagement()">
        <div class="common-button-card__header-container">
          <div class="common-button-card__title-container"
            [ngClass]="{'common-button-card__title-container--error': publicLink.errorHasProcessOps}">
            <div class="common-button-card__inner-title"
              [afTranslate]="'public-link.process-management'">
              _Gestión del proceso
            </div>
            <i class="lf-icon-process-settings common-icon__xl"></i>
          </div>
          <span class="common-button-card__description"
            [afTranslate]="'public-link.process-management-text'">
          </span>
        </div>
        <div class="common-button-card__footer-buttons">
          <div class="common-tag__mandatory-obligatory-message">
            <span class="common-tag__mandatory-text-asterisk">*</span>
            <span [ngClass]="{'common-tag__mandatory-label-text-obligatory--error': publicLink.errorHasProcessOps }"
              class="common-tag__mandatory-label-text-obligatory"
              [afTranslate]="'common.required-with-bracket'">
              (obligatorio)
            </span>
          </div>
          <div class="common-tag__warning-risk-xl"
            [ngClass]="publicLink.processManagementOk?'common-tag__warning-risk-xl--filled-green-disabled':'common-tag__warning-risk-xl--filled-red-disabled'">
            <i class="common-icon__md"
              [ngClass]="publicLink.processManagementOk?'lf-icon-check-round':'lf-icon-track-right'"></i>
            <span class="common-tag__warning-risk-label-text"
              [afTranslate]="publicLink.processManagementOk?'common.completed':'common.pending'">
              _Completado
            </span>
          </div>
        </div>
      </button>
      <button class="common-button-card__container"
        (click)="editReferenceDocument()">
        <div class="common-button-card__header-container">
          <div class="common-button-card__title-container">
            <div class="common-button-card__inner-title"
              [afTranslate]="dataProtectionView ? 'public-link.data-protection-documentation-new' : 'public-link.reference-documents'">
            </div>
            <i class="lf-icon-document common-icon__xl"></i>
          </div>
          <span class="common-button-card__description"
            [afTranslate]="dataProtectionView ? 'public-link.data-protection-documentation-text' : 'public-link.reference-documents-text'">
          </span>
        </div>
        <div class="common-button-card__footer-buttons">
          <div class="common-tag__warning-risk-xl"
            [ngClass]="publicLink.additionalCfgOk?'common-tag__warning-risk-xl--filled-green-disabled':'common-tag__warning-risk-xl--filled-yellow-disabled'">
            <i class="common-icon__md"
              [ngClass]="publicLink.additionalCfgOk?'lf-icon-check-round':'lf-icon-track-right'"></i>
            <span class="common-tag__warning-risk-label-text"
              [afTranslate]="publicLink.additionalCfgOk?'common.completed':'common.pending'">
              _Completado
            </span>
          </div>
        </div>
      </button>
    </div>
    <div class="common-modal__footer">
      <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_Cancelar</span>
      </button>
      <button class="common-button__text"
        (click)="publishConcept()">
        <span class="common-button__text-title"
          [afTranslate]="publicLink.published?'expanded-menu.unpublish':'common.publish'">_Publicar</span>
      </button>
    </div>
  </div>
</div>
